import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { MySharedService } from '../App/shared.service';
declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;
@Component({
    templateUrl: './AppViews/SiteMaster/siteMaster.html',
})

export class SiteMasterComponent implements OnInit {
    userDetail: any;
    public constants: Constants;
    public siteMaster: any[] = [];
    public showLoader = false;
    constant: Constants;
    public siteMasterStatus: any[] = [];
    public filterSiteMasterStatus: any = "";
    public Search: any = "";
    public addSiteMasterData: any = { addSiteMasterIsActive: "" };
    public editSiteMasterData: any = { editSiteMasterIsActive: "" };
    public isAdd: boolean = true;
    active = true;
    public existsSiteMasterName: boolean = false;
    public isFormSubmitted: boolean = false;

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.filterSiteMasterStatus = this.constants.enumUserStatus["Active"];
    }

    newForm() {
        this.active = false;
        setTimeout(() => this.active = true, 0);
    }

    ngOnInit() {

        this.getStatus();
        this.getSiteMaster();
    }
    public AddSiteMasterFormLoad() {
        $('#btnAddSiteMasterForm').trigger('click');
    }

    public ResetForm(form: any) {
        form.reset();
        form.resetForm();
        this.isFormSubmitted = false;
        setTimeout(() => this.addSiteMasterData.addSiteMasterIsActive = true, 0);
    }
    ExportItems() {
        ExportToExcel(this.siteMaster, "SiteMaster",
            ["SiteName", "Status"],
            ["Site Name", "Status"]);
    }

    ngAfterViewInit() {
        $("#show-filter").click(function () { $(".filter-form").slideToggle() });
    }



    public getStatus() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetParameter', { "ParameterTypeId": this.constants.enumParamterTypeName["UserStatus"] }).subscribe(
            data => {
                this.siteMasterStatus = data["Parameter"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constant.globalError);
            },
            () => {
                console.log("in completed");
                this.showLoader = false;
            }
        );
    }

    public getSiteMaster() {
        this.showLoader = true;
        this._httpService.ajaxPost('SiteMaster/GetSiteMaster', { "SiteId": 0, "IsActive": this.filterSiteMasterStatus }).subscribe(
            data => {
                this.siteMaster = data["SiteMasterList"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constant.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public clearFilter() {
        this.filterSiteMasterStatus = this.constants.enumUserStatus["Active"];
        this.Search = "";
    }

    public CancelAddSiteMaster() {
        this.existsSiteMasterName = false;
        this.addSiteMasterData = { addSiteMasterIsActive: "" };
        this.newForm();
        $('#addSiteMaster').modal('hide');
        this.isAdd = true;
    }

    public CancelEditSiteMaster() {
        this.existsSiteMasterName = false;
        this.editSiteMasterData = {};
        this.newForm();
        $('#editSiteMaster').modal('hide');
        this.isAdd = true;
    }

    public AddSiteMaster(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid) {
            this.existsSiteMasterName = false;
            this.siteMaster.forEach(element => {
                if (element.SiteName.trim().toLowerCase() == this.addSiteMasterData.addSiteMasterName.trim().toLowerCase()) {
                    this.existsSiteMasterName = true;
                }
            })
            if (!this.existsSiteMasterName) {
                let objItem: any = {};
                objItem.SiteId = 0;
                objItem.SiteName = this.addSiteMasterData.addSiteMasterName;
                objItem.IsActive = this.addSiteMasterData.addSiteMasterIsActive;
                objItem.UserId = this.userDetail.SiteUserId;
                this.addEditSiteMaster(objItem);
                $('#addSiteMaster').modal('hide');
                this.addSiteMasterData = {};
                this.newForm();
                this.isAdd = true;
            }
        }
    }

    public EditSiteMaster(item: any) {
        $('#btnEditSiteMasterForm').trigger('click');
        this.isAdd = false;
        this.EditSiteMasterChange(item.SiteId);

    }
    public EditSiteMasterChange(itemId) {
        let objItem: any = {};
        objItem = JSON.parse(JSON.stringify(this.siteMaster.filter((siteMaster) => siteMaster.SiteId == itemId)[0]));
        this.editSiteMasterData.editSiteId = objItem.SiteId;
        this.editSiteMasterData.editSiteMasterName = objItem.SiteName;
        this.editSiteMasterData.editSiteMasterIsActive = objItem.IsActive;
    }

    public UpdateSiteMaster(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid) {
            this.existsSiteMasterName = false;
            this.siteMaster.forEach(element => {
                if (element.SiteId != this.editSiteMasterData.editSiteId && element.SiteName.trim().toLowerCase() == this.editSiteMasterData.editSiteMasterName.trim().toLowerCase()) {
                    this.existsSiteMasterName = true;
                }
            })

            if (!this.existsSiteMasterName) {
                let objItem: any = {};
                objItem.SiteId = this.editSiteMasterData.editSiteId;
                objItem.SiteName = this.editSiteMasterData.editSiteMasterName;
                objItem.IsActive = this.editSiteMasterData.editSiteMasterIsActive;
                objItem.UserId = this.userDetail.SiteUserId;
                this.addEditSiteMaster(objItem);
                $('#editSiteMaster').modal('hide');
                this.editSiteMasterData = {};
                this.newForm();
                this.isAdd = true;
            }
        }
    }

    addEditSiteMaster(objItem) {
        this.showLoader = true;
        this._httpService.ajaxPost('SiteMaster/AddUpdateSiteMaster', objItem).subscribe(
            data => {

                var msg = data["Status"].Message.split('|');
                if (msg.length > 1) {
                    msg[0] = msg[0];
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                else {
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                this.getSiteMaster();
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constant.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }
}


/** WEBPACK FOOTER **
 ** ./TypeScripts/SiteMaster/siteMaster.component.ts
 **/